// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  AvailableDelegation,
  AvailableDelegationsListOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a AvailableDelegations. */
export interface AvailableDelegations {
  /**
   * Gets all of the available subnet delegations for this subscription in this region.
   * @param location The location of the subnet.
   * @param options The options parameters.
   */
  list(
    location: string,
    options?: AvailableDelegationsListOptionalParams,
  ): PagedAsyncIterableIterator<AvailableDelegation>;
}
